@if(!vdiModeOn){
<div class="d-flex flex-column h-100 synchpc-bg-primary text-grey">
  <div>
    <app-header *ngIf="!hideHeader"></app-header>
  </div>
  <div
    class="d-flex flex-grow-1"
    [style.max-height]="
      isUserLoggedIn ? (!hideHeader ? 'calc(100vh - 45px)' : '100vh') : '100vh'
    "
  >
    <div *ngIf="isUserLoggedIn && !hideHeader" class="menu">
      <app-menu></app-menu>
    </div>
    <div
      class="flex-grow-1 main"
      [style.borderTopLeftRadius]="isUserLoggedIn ? '.3rem' : '0'"
    >
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
} @else{
<div class="d-flex flex-column h-100 synchpc-bg-primary text-grey">
  <div
    class="flex-grow-1 main"
    [style.borderTopLeftRadius]="isUserLoggedIn ? '.3rem' : '0'"
  >
    <router-outlet></router-outlet>
  </div>
</div>
}
